(function () {
    'use strict';

    angular.module('modules.spotlight', ['gettext', 'cfp.hotkeys', 'angular-click-outside']);
})();
